import type { ClaimJob } from "./claim.worker";
import { claimMac } from "./cmac";

export function base64ToBytes(b64: string): Uint8Array {
  const bin = atob(b64);
  return Uint8Array.from(bin, (c) => c.charCodeAt(0));
}

export function bytesToBase64(bytes: Uint8Array): string {
  return btoa(String.fromCharCode(...bytes));
}

/** The claim MAC, computed in a Web Worker where the browser has them (always, in the supported browsers). */
export async function computeClaimMac(job: ClaimJob): Promise<Uint8Array> {
  if (typeof Worker === "undefined") return claimMac(job.kLocal, job.deviceId, job.lgen, job.nonce);
  const worker = new Worker(new URL("./claim.worker.ts", import.meta.url), { type: "module" });
  try {
    return await new Promise<Uint8Array>((resolve, reject) => {
      worker.onmessage = (e: MessageEvent<{ mac?: Uint8Array; error?: string }>) =>
        e.data.mac ? resolve(e.data.mac) : reject(new Error(e.data.error ?? "claim worker failed"));
      worker.onerror = (e) => reject(new Error(e.message));
      worker.postMessage(job);
    });
  } finally {
    worker.terminate();
  }
}
